const SearchInput = ({ value, onChange, placeholder }) => (
  <div className="admin-list__search">
    <i className="pi pi-search" aria-hidden="true" />
    <input
      type="search"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      aria-label={placeholder}
    />
  </div>
);

export default SearchInput;
